exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-header {\n  height: 56px;\n  padding: 10px;\n  text-align: center;\n}\n\nh1 {\n  font-size: 27px;\n  font-weight: 300;\n}\n\nhr {\n  margin-top: 10px;\n  margin-bottom: 5px;\n}\n\n.time-tag {\n  font-size: 1.2em !important;\n  padding: 5px;\n}\n\n.w3-container {\n  text-align: center;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/trevor/src/src-westoaks3/west-oaks/src/app/display-meeting/display-meeting.component.css
// module id = ../../../../../src/app/display-meeting/display-meeting.component.css
// module chunks = main